/**
 * Error handling utilities for authentication
 */
import type { AuthError } from '../types/auth.types';

/**
 * Get user-friendly error message based on status code
 */
export const getErrorMessage = (status: number): string => {
  switch (status) {
    case 401:
      return 'Invalid credentials. Please check your email and password.';
    case 429:
      return 'Too many login attempts. Please try again later.';
    case 500:
      return 'Server error. Please try again later.';
    default:
      return 'An error occurred. Please try again.';
  }
};

/**
 * Create an AuthError object
 */
export const createAuthError = (status: number, message?: string): AuthError => {
  return {
    status,
    message: message || getErrorMessage(status),
  };
};

/**
 * Handle fetch errors and convert to AuthError
 */
export const handleFetchError = (error: unknown): AuthError => {
  // If error is already an AuthError, re-throw it
  if (error && typeof error === 'object' && 'status' in error) {
    return error as AuthError;
  }

  // Network or other errors
  return createAuthError(0, 'Network error. Please check your connection and try again.');
};
